module.exports = __webpack_public_path__ + "img/img16.b0e0353c.svg";